import React, { useEffect, useRef, useState } from 'react';
import confirmationLoader from './confirmationLoader.json'
import confirmationLoaderEnd from './confirmationLoaderEnd.json'
import Lottie from 'lottie-react'
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import GlobalFooter from './GlobalFooter';
function PaymentConfirmation() {
    const location = useLocation();  
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isTimeLimitExceeded, setIsTimeLimitExceeded] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [isSuccess,setIsSuccess] = useState(false)
    const record = JSON.parse(localStorage.getItem("auth"))


    const data = location.state || {}

    function timeout(number) {
        return new Promise( res => setTimeout(res, number) );
      }
    
      const handleGetHelp = ()=>{
        navigate('/help')
      }

      useEffect(() => {
        let intervalId;
        let timeoutId;
        
        const makeRequest = async () => {
    
          console.log("data : ",data)
          const trans_id = data?.data?.transfer?.id
          try{
    
           
            const result ={
              access_token:data?.data?.access_token,
              transfer_id:trans_id
            }
            
            // var metrans = localStorage.getItem('nubanTrans');      
            const url = `https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/transfer-status`
            
            let res = await axios.post(url,{...result}) 
            
           
            // const message = res?.data?.message.toLowerCase();
            const trans_status = res.data.transfer.status;
            if(trans_status ==="pending" || trans_status==="approved"){
             
              const transferSuccess = res?.data?.data
              // toast.success(res.data.message);
              clearInterval(intervalId);
              clearTimeout(timeoutId);
              setIsSuccess(true)
              setIsTimeLimitExceeded(true);
              localStorage.removeItem('access_token');
              await timeout(3000)
              
              navigate("/pages/success-payment",{state:{transferSuccess}});
              // navigate away from this page // 
             //  navigate('/success')
            }else{
              console.log('Waiting for a successful response...');
            }
          }catch(err){
            console.log(err)
            setIsTimeLimitExceeded(true);
            clearInterval(intervalId);
            clearTimeout(timeoutId);
            navigate("/pages/payment-failed");
            const errorMessage = err?.response?.data?.message || err.message || "Server Error"
            toast.error(errorMessage);
          }
        };
    
        // Initialize the responseSuccessful flag to false
      
        const startPolling = () => {
    
          makeRequest();
          intervalId = setInterval(() => {
            makeRequest()
              .finally(() => {
                setIsLoading(false);
              });
          }, 5000); // 5 seconds
    
          // Set a timeout for 10 minutes (600,000 milliseconds)
          const timeoutDuration = 600000; // 10 minutes
          timeoutId = setTimeout(() => {
            clearInterval(intervalId);
            setIsTimeLimitExceeded(true);
            setIsLoading(false);
          }, timeoutDuration); // 10 minutes
    
          // Update timeLeft every second
          const updateTimer = () => {
            const elapsed = (timeoutDuration - (Date.now() - startTime)) / 1000;
            setTimeLeft(Math.max(0, Math.round(elapsed)));
          };
          
          const startTime = Date.now();
          const timerIntervalId = setInterval(updateTimer, 1000);
    
          // Clear the timer interval when the component unmounts
          return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
            clearInterval(timerIntervalId);
          };
        };
    
        startPolling();
      
        return () => {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
        };
        // eslint-disable-next-line 
      }, []);
    
      useEffect(() => {
        if (isTimeLimitExceeded) {
          // navigate("/pages/expire");
        }
      }, [isTimeLimitExceeded, navigate]);
    
      const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
      };

      const handleClose = ()=>{
        navigate('/pages/global-payment')
      }

  return (
    <div className='global_layout'>
         {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
          } */}
    
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt=''/> */}
                <img src='/images/global/close.svg' alt='' style={{marginLeft:"auto"}} onClick={handleClose}/>
            </div>

            <div className='global_content'>
                <div className='glob_avater'>
                        {
                            record?.avatar ?
                            
                            <img className='img_avater' src={record?.avatar} alt=''/>:
                            
                            <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0,1)}</p>
                        }
                </div>
                <p className='glob_title'>Payment confirmation</p>
                <p className='glob_desc'>We’re confirming your payment. Please keep this page opened.</p>

                {
                    !isTimeLimitExceeded ?
                    <div className='lottie_loader'>
                    <Lottie animationData={confirmationLoaderEnd} />
                </div>:
                    <div className='lottie_loader'>
                    <Lottie loop={false} animationData={confirmationLoader} />
                </div>

                }
                
                

                <div className='time_count'>
                    <img src='/images/global/information.svg' alt=''/>
                    <p className='time_count_value'>Please wait for {formatTime(timeLeft)} mins</p>
                </div>
                {/* Phone Number */}
               
                {/* <button className='btn' style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px",gap:"8px",background:"#228985",borderRadius:"10000px"}}>
                        <p>Continue</p>
                        <img src='/images/global/activeArrow.svg' alt='' />
                </button> */}

            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default PaymentConfirmation